export class Car {
    constructor(plate, parking) {
        this.plate = plate;
        this.parking = parking;
    }
}
